import { styled } from "@mui/material/styles";
import PromptModal from "components/PromptModal";
import BottomNav from "layout/BottomNav";
import DashboardNavbar from "layout/DashboardNavbar";
import DashboardSidebar from "layout/DashboardSidebar";
import SectionSubNav from "layout/SectionSubNav";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const RootStyle = styled("div")(({ theme }) => ({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
  height: "100%",
  backgroundColor: "#F5F5F5",
}));
// ----------------------------------------------------------------------

export default function Dashboard() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location.pathname]);

  return (
    <RootStyle>
      <PromptModal />
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />
      <SectionSubNav />
      <BottomNav />
      <Outlet />
    </RootStyle>
  );
}
